var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        {
          ref: "paymentFileInfoRowForm",
          attrs: { novalidate: "", tag: "form" }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c("icon-view", {
                  attrs: {
                    gradient: "",
                    icon: _vm.icon,
                    "icon-background": "#f87058",
                    "icon-color": "#fff",
                    "icon-size": "15px",
                    title: _vm.title,
                    variant: "custom-icon-view"
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "mt-3" },
            _vm._l(_vm.items, function(item, index) {
              return _c(
                "div",
                { key: `file-item-${index}`, staticClass: "mb-2" },
                [
                  _c(
                    "custom-callout",
                    {
                      attrs: {
                        controlled: true,
                        disabled: _vm.allowUploadAnswerFiles(item),
                        opened: item.isOpen
                      },
                      on: {
                        "click:open": function($event) {
                          return _vm.onOpenDetails(item)
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "edition",
                            fn: function() {
                              return [
                                _c("div", { staticClass: "bg-gray p-2" }, [
                                  _c(
                                    "div",
                                    { staticClass: "bg-white rounded p-3" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row bg-secondary-3 mx-3 rounded p-3 mb-3"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 d-flex align-items-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "color-secondary-6 font-16 font-weight-bold"
                                                },
                                                [_vm._v(" LOG ")]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col d-flex align-items-center"
                                            },
                                            [
                                              _c("check-box", {
                                                staticClass: "w-auto",
                                                attrs: {
                                                  disabled:
                                                    item.logDocumentAttachmentId ||
                                                    _vm.logFile
                                                },
                                                model: {
                                                  value: item.logFileEmpty,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "logFileEmpty",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.logFileEmpty"
                                                }
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "color-secondary-6 font-weight-normal font-16 mt-1"
                                                },
                                                [_vm._v(" Archivo en Blanco ")]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col d-flex align-items-center"
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "color-black font-16 font-weight-normal"
                                              })
                                            ]
                                          ),
                                          _vm.hideInEmptyFile(
                                            item,
                                            "logDocumentAttachment"
                                          ) ||
                                          _vm.isReadOnly(item) ||
                                          !item.isLastFile
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-items-center"
                                                },
                                                [
                                                  _c("custom-file-input", {
                                                    attrs: {
                                                      accept: ".log",
                                                      "attachment-id":
                                                        item.logDocumentAttachmentId,
                                                      disabled: _vm.hideRemoveFileLOG(
                                                        item
                                                      ),
                                                      "on-download":
                                                        _vm.onDownloadFile
                                                    },
                                                    model: {
                                                      value: _vm.logFile,
                                                      callback: function($$v) {
                                                        _vm.logFile = $$v
                                                      },
                                                      expression: "logFile"
                                                    }
                                                  }),
                                                  _vm.hideRemoveFileLOG(item) &&
                                                  !_vm.isReadOnly(item)
                                                    ? _c(
                                                        "action-button",
                                                        {
                                                          attrs: {
                                                            i:
                                                              "fas fa-times-circle",
                                                            variant:
                                                              "outline-danger btn-cancel danger pt-2 px-3"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.onDeleteAnswerFile(
                                                                item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v(" Eliminar ")]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row bg-secondary-3 mx-3 rounded p-3 mb-3"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-3 d-flex align-items-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "color-secondary-6 font-16 font-weight-bold"
                                                },
                                                [_vm._v(" REJ ")]
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col d-flex align-items-center"
                                            },
                                            [
                                              _c("check-box", {
                                                staticClass: "w-auto",
                                                attrs: {
                                                  disabled:
                                                    item.rejDocumentAttachmentId ||
                                                    _vm.rejFile
                                                },
                                                model: {
                                                  value: item.rejFileEmpty,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "rejFileEmpty",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.rejFileEmpty"
                                                }
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "color-secondary-6 font-weight-normal font-16 mt-1"
                                                },
                                                [_vm._v(" Archivo en Blanco ")]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm.hideInEmptyFile(
                                            item,
                                            "rejDocumentAttachment"
                                          ) ||
                                          _vm.isReadOnly(item) ||
                                          !item.isLastFile
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex align-items-center"
                                                },
                                                [
                                                  _c("custom-file-input", {
                                                    attrs: {
                                                      accept: ".rej",
                                                      "attachment-id":
                                                        item.rejDocumentAttachmentId,
                                                      disabled: _vm.hideRemoveFileREJ(
                                                        item
                                                      ),
                                                      "on-download":
                                                        _vm.onDownloadFile
                                                    },
                                                    model: {
                                                      value: _vm.rejFile,
                                                      callback: function($$v) {
                                                        _vm.rejFile = $$v
                                                      },
                                                      expression: "rejFile"
                                                    }
                                                  }),
                                                  _vm.hideRemoveFileREJ(item) &&
                                                  !_vm.isReadOnly(item)
                                                    ? _c(
                                                        "action-button",
                                                        {
                                                          attrs: {
                                                            i:
                                                              "fas fa-times-circle",
                                                            variant:
                                                              "outline-danger btn-cancel danger pt-2 px-3"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.onDeleteAnswerFile(
                                                                item
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [_vm._v(" Eliminar ")]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm.allowSaveUploadAnswerFiles(item)
                                        ? _c("div", { staticClass: "row" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col d-flex justify-content-end align-items-center pr-4 mr-2"
                                              },
                                              [
                                                _c(
                                                  "action-button",
                                                  {
                                                    attrs: {
                                                      i: "fas fa-times-circle",
                                                      variant:
                                                        "outline-danger btn-cancel danger m-2 pl-4 pr-4"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.onCancelAnswerFile(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(" Cancelar ")]
                                                ),
                                                _c("action-button", {
                                                  attrs: {
                                                    i: "fas fa-save",
                                                    text: "Guardar",
                                                    variant: "success pl-4 pr-4"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.saveAnswerFiles(
                                                        item
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _c("div", { staticClass: "py-3 px-3" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-4 col-sm col-12" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "color-secondary-6 font-14 font-weight-normal"
                              },
                              [_vm._v(" Información del Archivo: ")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "color-black font-weight-bold font-16 mr-3"
                              },
                              [_vm._v(" " + _vm._s(item.fileName) + " ")]
                            )
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col col-sm col-6 mt-3 mt-md-0 mt-sm-3"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-secondary-6 font-14 font-weight-normal"
                                },
                                [_vm._v(" Records: ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-weight-bold font-16 mr-3"
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(item.fileRecordCount) + " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col col-sm col-6 mt-3 mt-md-0 mt-sm-3"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-secondary-6 font-14 font-weight-normal"
                                },
                                [_vm._v(" Error: ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-weight-bold font-16 mr-3"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.fileRecordErrorCount) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col col-sm col-12 mt-3 mt-md-0 mt-sm-3"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-secondary-6 font-14 font-weight-normal"
                                },
                                [_vm._v(" Creador por: ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-weight-bold font-16 mr-3"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(item.createByName) +
                                      " / " +
                                      _vm._s(_vm._f("date")(item.createDate)) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-1 col-sm col-12 d-flex align-items-center justify-content-end pr-5"
                            },
                            [
                              _c(
                                "action-button",
                                {
                                  staticClass:
                                    "outline-success pr-1 btn-block-xs-only",
                                  attrs: { i: "fa fa-file-download" },
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit(
                                        "on-download-account-file",
                                        item
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-inline-block d-md-none d-sm-inline-block"
                                    },
                                    [_vm._v(" Descargar ")]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _c("div", { staticClass: "border-bottom mr-3 mt-3" }),
                        _c(
                          "div",
                          { staticClass: "mt-3 d-flex align-items-center" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "color-secondary-6 font-14 font-weight-normal mr-3"
                              },
                              [_vm._v(" Archivos de Respuestas: ")]
                            ),
                            _vm.allowUploadAnswerFiles(item)
                              ? _c("action-button", {
                                  staticClass: "border btn px-4",
                                  attrs: {
                                    i: "fas fa-file-plus color-green",
                                    text: "Presione aquí para anejar documentos"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.onOpenUploadAnswerFiles(item)
                                    }
                                  }
                                })
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "color-gray-6 font-weight-bold font-16"
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(item.answerFileNames) + " "
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-end mt-3" },
                    [
                      _vm.allowModifyFile(item)
                        ? _c("action-button", {
                            staticClass: "success",
                            attrs: {
                              i: "fas fa-file-plus",
                              text: "Generar Nuevo Archivo"
                            },
                            on: {
                              click: function($event) {
                                return _vm.generateNewFileHandler(item)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          ),
          _vm.items.length === 0
            ? _c(
                "div",
                {
                  staticClass:
                    "bg-secondary-3 rounded p-4 mt-2 d-flex align-items-center justify-content-center"
                },
                [
                  _c("h1", { staticClass: "far fa-folder-open color-gray-3" }),
                  _c(
                    "div",
                    {
                      staticClass:
                        "color-gray-3 font-16 ml-4 font-weight-normal"
                    },
                    [_vm._v(" " + _vm._s(_vm.emptyText) + " ")]
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }